// extracted by mini-css-extract-plugin
export var menu = "style-module--menu--L-PyN";
export var menuLogo = "style-module--menuLogo--1kS61";
export var menuLogoDescr = "style-module--menuLogoDescr--3zv8V";
export var menuSwitch = "style-module--menuSwitch--27JIU";
export var menuIcon = "style-module--menuIcon--9frE3";
export var submenu = "style-module--submenu--2YlER";
export var submenuLink = "style-module--submenuLink--3H_TF";
export var submenuLinkWidth = "style-module--submenuLinkWidth--2-GYM";
export var submenuLinkActive = "style-module--submenuLinkActive--1cu-T";